module.exports = __webpack_public_path__ + "static/meledia.fe3db86f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/meledia.png
// module id = 714
// module chunks = 23899280101116